import { Tab, TabProps, useRecordContext } from 'react-admin';
import { TAB_LABEL } from './constants';
import AttemptsSection from './AttemptsSection';
import ErrorState from './ErrorState';
import ExcludeToggle from './ExcludeToggle';
import Header from './Header';
import HistorySection from './HistorySection';
import LoadingState from './LoadingState';
import PolicyStrip from './PolicyStrip';
import StateBanner from './StateBanner';
import { TabBody } from './styled';
import useController from './useController';
import type { FCRAWorker } from '@/types/turn-api';

const IDVTab = (props: Partial<TabProps>) => {
  const record = useRecordContext<FCRAWorker.Details>();
  const { ops, loading, excludeSaving, markSavingId, error, refetch, setExcluded, markAttempt } = useController();
  const excludeAction = ops.actions?.exclude_auto_withdraw;
  const excludeBlocked = Boolean(ops.read_only) || excludeAction?.allowed === false;
  const excludeReason = excludeAction?.reason ?? ops.read_only_reason ?? null;

  return (
    <Tab label={TAB_LABEL} {...props}>
      <TabBody>
        <Header
          actions={
            <ExcludeToggle
              excluded={ops.exclude.excluded}
              disabled={loading || Boolean(error) || excludeSaving || excludeBlocked}
              disabledReason={excludeBlocked && !loading && !excludeSaving ? excludeReason : null}
              onChange={setExcluded}
            />
          }
        />
        {loading ? (
          <LoadingState />
        ) : error ? (
          <ErrorState message={error} onRetry={refetch} />
        ) : (
          <>
            <StateBanner ops={ops} />
            <PolicyStrip ops={ops} partnerName={record?.partner?.name} />
            <AttemptsSection ops={ops} savingAttemptId={markSavingId} onMarkAs={markAttempt} />
            <HistorySection history={ops.history} workerId={record?.id} />
          </>
        )}
      </TabBody>
    </Tab>
  );
};

export default IDVTab;
